import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HighCostProvider } from "../../context/HighCostContext";
import HighCostPanel from "./HighCostPanel";

const HighCostPage = () => {
  const { t } = useTranslation();

  return (
    <HighCostProvider>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
          {t("nav.highCost", "High Cost")}
        </Typography>
        <HighCostPanel />
      </Box>
    </HighCostProvider>
  );
};

export default HighCostPage;
